// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title-select{max-width:100px}`, "",{"version":3,"sources":["webpack://./src/frontend/components/atoms/titlesSelect/styles.titles-select.scss"],"names":[],"mappings":"AAEA,cACE,eAAA","sourcesContent":["@use \"../../../colors.scss\";\n\n.title-select{\n  max-width: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
